import img1 from "../../../assets/img/destination/dubai.png";
import img2 from "../../../assets/img/destination/vietnam.png";
import img3 from "../../../assets/img/destination/malaysia.png";
import img4 from "../../../assets/img/destination/baku.png";
import img5 from "../../../assets/img/destination/thailand.png";
import img6 from "../../../assets/img/destination/europe.png";
import img7 from "../../../assets/img/destination/london.png";
import img8 from "../../../assets/img/destination/uk.png";

export const TopDestinationsData = [
  {
    id: 1,
    img: img1,
    heading: "Dubai",
  },
  {
    id: 2,
    img: img2,
    heading: "Vietnam",
  },
  {
    id: 3,
    img: img3,
    heading: "Malaysia",
  },
  {
    id: 4,
    img: img4,
    heading: "Baku",
  },
  {
    id: 5,
    img: img5,
    heading: "Thailand",
  },
  {
    id: 6,
    img: img6,
    heading: "Europe",
  },
  {
    id: 7,
    img: img7,
    heading: "London",
  },
  {
    id: 8,
    img: img8,
    heading: "UK",
  },
];
